import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    addressList: [],
    allCoins: [],
    pagination: { page: 1, size: 10 },
    totalCount: 0,
  },
  mutations: {
    setAddressList(state, payload) {
      state.addressList = (payload.list || []).slice();
      state.totalCount = payload.totalCount;
    },
    setAllcoins(state, payload) {
      state.allCoins = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    clear({commit}){
      commit('setAddressList', {totalCount:0,list:[]});
    },
    getAllCoins({ commit }) {
      api.getAllCoins().then(({ data }) => {
        commit('setAllcoins', data);
      });
    },
    list({ commit }, { uid, from, to, coinType, page=1, size=10 }) {
      api.getStatistics({ uid, from, to, coinType, page, size}).then(({ data }) => {
        commit('setPagination', { page, size });
        commit('setAddressList', data);
      });
    },
    create({ state, commit }, {coinType, address, memo}) {
      return new Promise(resolve => {
        api.addNewCoinAddress({
           coinType, address, memo
        }).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('userstatistics', store);
